import http from 'axios'


export default {
  getReglementCampagne: (anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/reglement-campagne?anneeRecolte=${anneeRecolte}&codeGraineRs3=${codeGraineRs3}`)
  },

  telechargerDocumentPdf (reglementCampagneID) {
    return http.get(`/web/v1/reglement-campagne/${reglementCampagneID}/pdf`, {
      responseType: 'blob'
    })
  }
}
